import { useEffect, useState } from "react";
import { apiRequest } from "../utils/ApiRequest";
import { POLL_ENABLED } from "../utils/poll";

// The survey that is open right now (question, options, closing time), fetched once per page load and shared.
// poll is null when no survey is open; loaded tells you the answer has arrived.
const cache = { loaded: false, poll: null, promise: null };

export function useCurrentPoll() {
  const [state, setState] = useState({ poll: cache.poll, loaded: cache.loaded });

  useEffect(() => {
    if (!POLL_ENABLED) {
      setState({ poll: null, loaded: true });
      return undefined;
    }
    if (cache.loaded) {
      setState({ poll: cache.poll, loaded: true });
      return undefined;
    }

    let cancelled = false;
    if (!cache.promise) {
      cache.promise = apiRequest({ script: "poll-current", data: {}, token: null })
        .then((res) => {
          cache.poll = res?.success ? res.poll || null : null;
        })
        .catch(() => {})
        .finally(() => {
          cache.loaded = true;
        });
    }
    cache.promise.then(() => {
      if (!cancelled) setState({ poll: cache.poll, loaded: true });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
